@if (errorMessage) {
	<app-alert 
		[title]="'Error de autenticación'" 
		[message]="errorMessage" 
		[type]="'alert'"
		[duration]="4000">
	</app-alert>
}

<div class="min-h-screen flex items-center justify-center bg-linear-to-br from-blue-50 to-blue-200 py-12 px-4">
  <div class="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 flex flex-col items-center">
    <div class="mb-6 flex flex-col items-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 text-blue-600 mb-2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h1.5m9 0h-9" />
      </svg>
      <h2 class="text-2xl font-bold text-gray-900">Iniciar sesión</h2>
      <p class="text-gray-500 text-sm mt-1">Accede con tu cuenta para continuar</p>
    </div>
    <form (ngSubmit)="onSubmit()" #loginForm="ngForm" class="w-full space-y-5">
      <div>
        <label for="username" class="block text-sm font-medium text-gray-700 mb-1">Usuario</label>
        <input type="text" id="username" name="username" [(ngModel)]="username" required
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 bg-gray-50" />
      </div>
      <div>
        <label for="password" class="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
        <input type="password" id="password" name="password" [(ngModel)]="password" required
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 bg-gray-50" />
      </div>
      <button type="submit" [disabled]="isLoading"
        class="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2">
        @if (isLoading) {
          <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
          </svg>
        }
        <span>Entrar</span>
      </button>
    </form>
  </div>
</div>
